<template>
  <div
    ref="wrapper"
    class="checkbox-container"
  >
    <div
      v-for="option, index in options"
      :key="option.value"
      class="checkbox-wrapper"
      :class="{[spacing]: index !== options.length - 1}"
    >
      <input
        :id="option.id || option.value"
        :name="option.name || name"
        type="checkbox"
        :aria-label="option.ariaLabel || option.label"
        :aria-describedby="'checkbox'+id"
        :value="option.value"
        :checked="inputValue.includes(option.value)"
        :aria-checked="inputValue.includes(option.value) ? 'true' : 'false'"
        :class="{
          'is-invalid-input': hasError,
        }"
        :disabled="option.disabled"
        @click="onClick(option)"
        @blur="handleChange"
      >
      <label
        :class="{ disabled: option.disabled }"
        :for="option.id || option.value"
      >
        <template v-if="option.labelType?.toLowerCase() === 'html'">
          <component
            :is="option.label"
            v-if="option.label"
          />
        </template>
        <template v-else>{{ option.label }}</template>
      </label>
      <component
        :is="option.additionalText"
        v-if="option.additionalText"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import generateRandomId from '../../utils/randomNumber';

const wrapper = ref(null);
const props = defineProps({
  name: {
    type: String,
    default: 'checkbox',
  },
  options: {
    type: Array,
    default: () => [],
  },
  spacing: {
    type: String,
    default: 'margin-bottom-xxs',
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  hasError: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['update:modelValue']);
const id = generateRandomId();
const inputValue = ref(props.modelValue);
const onClick = ({ value }) => {
  if (inputValue.value.includes(value)) {
    inputValue.value.splice(inputValue.value.indexOf(value), 1);
  } else {
    inputValue.value.push(value);
  }
  emit('update:modelValue', inputValue.value);
};
watch(() => props.modelValue, (newValue) => {
  inputValue.value = newValue;
});
const handleChange = (event) => {
  // inputValue.value should be empty, returning reference
  const isEmptyValue = event.value === undefined && inputValue.value.length === 0;

  // emit only when wrapper blur
  const isWrapperBlur = wrapper.value && !wrapper.value.contains(event.relatedTarget);
  if (isEmptyValue && isWrapperBlur) {
    emit('update:modelValue', inputValue.value);
  }
};
</script>
<style lang="scss" scoped>
@import "~@core/csg/src/scss/forms/forms.scss";
@include csg-forms;
</style>
